// extracted by mini-css-extract-plugin
export default {"courtContextMenu":"playing-surface-context-menu_courtContextMenu__ZOndZ","changeActionTypeMenu":"playing-surface-context-menu_changeActionTypeMenu__+uHSU"};